import { useContext } from "react";
import { FormContext } from "../contexts";

export const useFormContext = () => useContext(FormContext);
